"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _BoxComponent.default;
  }
});

var _BoxComponent = _interopRequireDefault(require("./Box-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }